import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import SyncIcon from "@mui/icons-material/Sync";
import EmailGenerateItems from "./EmailGenerateItems";
import { apiChatUrl } from "../../utils/config";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { Typography } from "@mui/material";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";

const EmailGenerate = (props: any) => {
  const { handleOpenAI, handleInsertReply, feedbackDetails } = props;
  const [generateReplies, setGenerateReplies] = useState<any>([]);
  const [aisuggestionloader, setAisuggestionloader] = useState(false);
  const [regenerateDisabled, setRegenerateDisabled] = useState(false);
  const userOrgId = localStorage.getItem("userOrgId");
  const [AIMessageId, setAIMessageId] = useState("");

  useEffect(() => {
    if (
      feedbackDetails &&
      feedbackDetails?.aiGeneratedReply &&
      feedbackDetails?.aiGeneratedReply.length > 0 &&
      feedbackDetails?.aiGeneratedReply[
        feedbackDetails?.aiGeneratedReply.length - 1
      ]?.chatbot &&
      feedbackDetails?.aiGeneratedReply[
        feedbackDetails?.aiGeneratedReply.length - 1
      ]?.chatbot != ""
    ) {
      const newreplydata =
        feedbackDetails?.aiGeneratedReply[
          feedbackDetails?.aiGeneratedReply.length - 1
        ].chatbot;
      const pattern1 =
        /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      const str1 = newreplydata.replace(
        pattern1,
        "<a style='color:#1b66e6' target='_blank' href='$1'>$1</a>"
      );
      const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
      const str2 = str1.replace(
        pattern2,
        '$1<a style="color:#1b66e6"  target="_blank" href="https://$2">https://$2</a>'
      );
      const sourcePattern = /Sources:(.*)/;
      const withoutSourcedata = str2.replace(sourcePattern, "");
      // setGenerateReplies((prevState: any) => [
      //   withoutSourcedata.replace(/\n/g, "<li class='bot-side-msg'>"),
      //   ...prevState,
      // ]);
      setGenerateReplies((prevState: any) => [
        {
          content: withoutSourcedata.replace(
            /\n/g,
            "<li class='bot-side-msg'>"
          ),
          message_id:
            feedbackDetails?.aiGeneratedReply[
              feedbackDetails?.aiGeneratedReply.length - 1
            ].message_id,
        },
        ...prevState,
      ]);
      const messagesContainer: any =
        document.getElementById("generateRepliesDiv");
      // messagesContainer.scrollTop = messagesContainer.scrollHeight;
      messagesContainer.scrollTop = 0;
    } else {
      fetchAISuggestion();
    }
  }, []);
  const fetchAISuggestion = async () => {
    const data = {
      "productId": feedbackDetails?.productId,
      "productVersion": feedbackDetails?.productVersion,
      "feedbackId": feedbackDetails?.id,
      "orgId": userOrgId,
    };
    try {
      setAisuggestionloader(true);
      const res: any = await fetch(`${apiChatUrl}/generate-reply`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-type": "application/json",
        },
      });
      setAisuggestionloader(false);
      const respData = await res.json();
      if (res?.status === 200) {
        if (respData && respData.response && respData.response.response) {
          // setAIMessageId(respData.response.message_id);
          const newreplydata = respData.response.response;
          const pattern1 =
            /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
          const str1 = newreplydata.replace(
            pattern1,
            "<a style='color:#1b66e6' target='_blank' href='$1'>$1</a>"
          );
          const pattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
          const str2 = str1.replace(
            pattern2,
            '$1<a style="color:#1b66e6"  target="_blank" href="https://$2">https://$2</a>'
          );
          const sourcePattern = /Sources:(.*)/;
          const withoutSourcedata = str2.replace(sourcePattern, "");
          // setGenerateReplies((prevState: any) => [
          //   withoutSourcedata.replace(/\n/g, "<li class='bot-side-msg'>"),
          //   ...prevState,
          // ]);
          setGenerateReplies((prevState: any) => [
            {
              content: withoutSourcedata.replace(
                /\n/g,
                "<li class='bot-side-msg'>"
              ),
              message_id: respData.response.message_id,
            },
            ...prevState,
          ]);
          const messagesContainer: any =
            document.getElementById("generateRepliesDiv");
          // messagesContainer.scrollTop = messagesContainer.scrollHeight;
          messagesContainer.scrollTop = 0;
        } else {
          setRegenerateDisabled(true);
          props.snackbarShowMessage(
            "No AI recommendations available",
            "warning",
            3000
          );
        }
      } else {
        setAisuggestionloader(false);
        setRegenerateDisabled(true);
        props.snackbarShowMessage(
          "Error Fetching AI Recommendations",
          "error",
          3000
        );
      }
    } catch (err) {
      setAisuggestionloader(false);
      setRegenerateDisabled(true);
      props.snackbarShowMessage(
        "Error Fetching AI Recommendations",
        "error",
        3000
      );
    }
  };
  const handleGenerateReply = () => {
    fetchAISuggestion();
  };
  return (
    <Box
      className={aisuggestionloader ? "loader ailoader" : ""}
      display="flex"
      flexDirection="column"
      flexBasis="35%"
      sx={{
        // border: "1px solid rgba(60, 64, 67, 0.2)",
        borderRadius: "14px",
        padding: "13px",
        background: "#E9EEFB",
      }}
    >
      <Box
        display="flex"
        sx={{ paddingBottom: "10px", borderBottom: "1px solid #00000030" }}
      >
        <Box
          sx={{
            display: "flex",
            borderRadius: "8px",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(40, 88, 211, 0.3)",
            color: "#2858D3",
            padding: "5px 10px",
            cursor: "pointer",
            width: "30px",
            height: "30px",
          }}
          onClick={handleOpenAI}
        >
          AI
        </Box>
      </Box>
      <Typography className="aisuggestionhelptext">
        You can also use the AI recommendations listed below
      </Typography>
      <Box display="flex" flexDirection="column" mt="10px">
        <Box
          id="generateRepliesDiv"
          sx={{
            display: "flex",
            height: "320px",
            overflowY: "auto",
            flexDirection: "column",

            // overflowX: "hidden",
            // "::-webkit-scrollbar": {
            //   width: 0,
            //   background: "transparent",
            // },
          }}
        >
          {generateReplies && generateReplies.length > 0 ? (
            generateReplies.map((data: any, index: any) => {
              return (
                <EmailGenerateItems
                  totalGeneratedItems={generateReplies.length}
                  index={index}
                  content={data.content}
                  messageId={data.message_id}
                  handleInsertReply={handleInsertReply}
                />
              );
            })
          ) : !aisuggestionloader ? (
            <>
              <Typography
                sx={{
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="aisuggestionhelptext"
                style={{ fontSize: "12px", margin: "auto", color: "#092146b8" }}
              >
                <SentimentNeutralIcon sx={{ marginBottom: 1 }} />
                No AI recommendations available{" "}
              </Typography>
            </>
          ) : (
            <></>
          )}
        </Box>
        <Box display="flex" mt="9px">
          <Button
            disabled={generateReplies.length == 5 || regenerateDisabled}
            variant="outlined"
            startIcon={<SyncIcon />}
            sx={{
              background: "#FFF!important",
            }}
            onClick={handleGenerateReply}
          >
            REGENERATE
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default withSnackbar(EmailGenerate);
